<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Reminder">
	<div class="closing-time-reminder-v2">
		<button
			type="button"
			class="closing-time-reminder-v2-close"
			(click)="dismiss()"
			[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
		>
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
		</button>

		<div class="closing-time-reminder-v2-header">
			<h2 class="closing-time-reminder-v2-title">{{ "CLOSING_TIME_REMINDER__TITLE" | transloco }}</h2>
			<p class="closing-time-reminder-v2-message">{{ "CLOSING_TIME_REMINDER__MESSAGE" | transloco }}</p>
		</div>

		<div class="closing-time-reminder-v2-actions">
			<button type="button" class="closing-time-reminder-v2-btn closing-time-reminder-v2-btn--outlined" (click)="dismiss()">
				{{ "CLOSING_TIME_REMINDER__DISMISS" | transloco }}
			</button>
			<button type="button" class="closing-time-reminder-v2-btn closing-time-reminder-v2-btn--filled" (click)="goToCloseLocation()">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">lock</span>
				{{ "CLOSING_TIME_REMINDER__GO_TO_CLOSE" | transloco }}
			</button>
		</div>
	</div>
</ng-container>

<ng-template #v1Reminder>
	<div class="closing-time-reminder-content">
		<div class="headline-container">
			<div class="headline">{{ "CLOSING_TIME_REMINDER__TITLE" | transloco }}</div>
			<div class="message">{{ "CLOSING_TIME_REMINDER__MESSAGE" | transloco }}</div>
		</div>

		<div class="button-container">
			<ion-button color="primary" shape="round" class="no-transform action-button" (click)="goToCloseLocation()">
				<ion-icon slot="start" name="lock-closed-outline"></ion-icon>
				{{ "CLOSING_TIME_REMINDER__GO_TO_CLOSE" | transloco }}
			</ion-button>
			<ion-button color="medium" shape="round" class="no-transform action-button" (click)="dismiss()">
				{{ "CLOSING_TIME_REMINDER__DISMISS" | transloco }}
			</ion-button>
		</div>
	</div>
</ng-template>
